export default (
    Object.freeze({
        supportedBrowsers: {
            Chrome: 96,
            CriOS: 96, // Chrome for iOS, based on Webkit
            Firefox: 84,
            FxiOS: 84, // Firefox for iOS, based on Webkit
            Safari: 14,
            Chromium: 96,
            Edge: 96
        },
        // currentAssetPath, currentSitePath and currentAppPath added on compile
        /*eslint-disable no-undef*/
        env: env,
        currentAssetPath: currentAssetPath,
        currentSitePath: currentSitePath,
        currentAppPath: currentAppPath
    })
);